import { Transform } from "class-transformer";
import { buildMessage, registerDecorator, ValidationOptions } from "class-validator";

const applicationIdPattern = /^[1-9][0-9]*$/;

export function IsBigInt(options?: ValidationOptions) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      ...(options && { options }),
      validator: {
        validate(value: bigint | null) {
          return typeof value === "bigint";
        },
        defaultMessage: (validationArguments) =>
          buildMessage((eachPrefix) => eachPrefix + `$property must match the pattern ${applicationIdPattern}`)(
            validationArguments
          )
      }
    });
  };
}

export const TransformStringToBigint = () =>
  Transform(({ value }) => {
    const isApplicationId = applicationIdPattern.test(value);
    if (isApplicationId) {
      return BigInt(value);
    }
    return null;
  });
